/**
 * VSI.3.1 — Renderer-Registry: vlo_type -> Renderer-Komponente.
 *
 * Erweiterbar (neue VLO-Typen in späteren Phasen ergänzen), ohne bestehende Renderer zu ändern.
 * Enthält keine Fachlogik. Fail-closed: unbekannte Typen liefern `null`.
 */
import {
  SafetySymbolsRenderer,
  PsaSummaryRenderer,
  HazardMarkersRenderer,
  LearningFocusRenderer,
} from "./renderers";

export const RENDERER_REGISTRY = Object.freeze({
  safety_symbols: SafetySymbolsRenderer,
  psa_summary: PsaSummaryRenderer,
  hazard_markers: HazardMarkersRenderer,
  // IMPLEMENT-4 / S3: Renderer existiert + registriert, aber NICHT live (Seiten-Consumer
  // filtern learning_focus per Whitelist heraus). Aktivierung erst nach Freigabe (S4).
  learning_focus: LearningFocusRenderer,
});

export function getRenderer(vloType) {
  return RENDERER_REGISTRY[vloType] || null;
}
